import { render } from "./reset_password.vue?vue&type=template&id=24d588a2&scoped=true"
import script from "./reset_password.vue?vue&type=script&lang=js"
export * from "./reset_password.vue?vue&type=script&lang=js"

import "./reset_password.vue?vue&type=style&index=0&id=24d588a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d588a2"]])

export default __exports__